import React from "react"
import { FaChevronLeft, FaChevronRight } from "react-icons/fa"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import classes from "./Navbar.module.scss"

const Navbar = props => {
  const {
    title = "",
    onLeftIconPress,
    rightSideComponent,
    variant = "spaceBetween",
    hideLeftIconInMobileView = false,
  } = props

  const i18n = useTranslation()[1]

  const isLtr = i18n.dir(i18n.language) === "ltr"

  if (variant === "compact") {
    return (
      <div className={classes["container"]}>
        <div className={classes["row"]}>
          {
            !!onLeftIconPress &&
            <button
              onClick={onLeftIconPress}
              className={clsx(classes["back"],
                isLtr && classes["back-ltr"],
                hideLeftIconInMobileView && classes["hide-in-mobile"]
              )}
            >
              {isLtr
                ?
                <FaChevronLeft
                  size={15}
                  color="white"
                />
                :
                <FaChevronRight
                  size={15}
                  color="white"
                />
              }
            </button>
          }
          {
            !!title &&
            <div className={classes["title"]}>
              {title}
            </div>
          }
        </div>
        {!!rightSideComponent && rightSideComponent()}
      </div>
    )
  }

  return (
    <div className={classes["container"]}>
      {
        !!onLeftIconPress &&
        <button
          onClick={onLeftIconPress}
          className={clsx(classes["back"],
            isLtr && classes["back-ltr"],
            hideLeftIconInMobileView && classes["hide-in-mobile"]
          )}
        >
          {isLtr
            ?
            <FaChevronLeft
              size={15}
              color="white"
            />
            :
            <FaChevronRight
              size={15}
              color="white"
            />
          }
        </button>
      }
      {
        !!title &&
        <div className={classes["title"]}>
          {title}
        </div>
      }
      {!!rightSideComponent && rightSideComponent()}
    </div>
  )
}

export default Navbar